import { TechemBreadcrumb } from '@techem/ui-components';
import React, { useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { paths } from 'frameworks_drivers/routes';

const CookieConsentPage: React.FC = () => {
  const { t } = useTranslation();
  const contentRef = useRef<any>(null);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://consent.cookiebot.eu/e9e5be24-ec43-4ad3-b103-bbb677ab0fcc/cd.js';
    script.async = true;

    if (contentRef.current) contentRef.current.appendChild(script);
  }, []);

  return (
    <Container className="py-4 mb-5">
      <div className="my-4">
        <TechemBreadcrumb
          items={[
            {
              additionalTestId: 'home',
              href: `/#${paths.LandingPage}`,
              title: t('breadcrumbHome')
            }
          ]}
          currentPageTitle={t('breadcrumbCookieConsent')}
        />
      </div>

      <h2
        className="text-start pe-4"
        style={{ fontSize: 40, lineHeight: '56px', marginBottom: 40 }}
      >
        <Trans i18nKey="breadcrumbCookieConsent" />
      </h2>

      <p>
        Hier können Sie Ihre Einwilligung zu Cookies ändern oder widerrufen und sehen, welche
        Cookies auf dieser Seite eingesetzt werden.
      </p>
      <p className="cookie-consent-interaction">
        <b>
          Klicken Sie auf&nbsp;
          <Link to={'/datenschutz/cookie-consent#CookieDeclarationUserStatusPanel'}>
            Einwilligung ändern
          </Link>
          &nbsp;oder&nbsp;
          <Link to={'/datenschutz/cookie-consent#CookieDeclarationUserStatusPanel'}>
            Einwilligung widerrufen
          </Link>
          &nbsp;kurz oberhalb der Tabelle, um Ihr Einwilligung anzupassen.
        </b>
      </p>
      <main ref={contentRef} />
    </Container>
  );
};

export default CookieConsentPage;
